<div class="bg-modal-cotizador py-2">
  <div class="container">
    <div class="row">
      <div class="col-12 d-md-none d-block mx-auto">
        <div (click)="onNoClick()" class="hide-rectangle"></div>
      </div>
    </div>
    <div class="row mx-2 mb-4 mt-3 mx-auto">
      <div class="col-11">
        <h4 style="font-size: 24px; font-weight: 800; margin-bottom: 0">
          {{ promocion.title }}
        </h4>
      </div>
      <div class="col-1 d-none d-lg-block">
        <button
          style="margin-top: -10px"
          (click)="onNoClick()"
          mat-icon-button
          color="accent"
          [attr.aria-label]="'MODAL.CLOSE_ARIA_LABEL' | translate"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <div class="container" style="overflow-y: auto">
      <div class="divisa-row">
        <div class="divisa-col-12 divisa-col-md-6 pr-md-2">
          <img class="img-fluid" [src]="promocion.banner" alt="" />
        </div>
        <div class="divisa-col-12 divisa-col-md-6 pl-md-2">
          <div class="" [innerHTML]="promocion.description | safeHtml"></div>
        </div>
      </div>
      <div class="divisa-row mt-4">
        <app-sucursal-card-promo
          [sucursal]="promocion.branch"
        ></app-sucursal-card-promo>
      </div>
      <div class="divisa-row mt-2">
        <div
          class="divisa-col-8 divisa-col-lg-3 divisa-space-between mx-auto my-2"
        >
          <a
            mat-fab
            [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_PHONE' | translate"
            color="accent"
            class="icon-sm-button"
            href="tel:{{ getBranchPhone() }}"
          >
            <mat-icon svgIcon="call"></mat-icon>
          </a>
          <a
            mat-fab
            [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_WHATSAPP' | translate"
            color="accent"
            class="icon-sm-button"
            target="_blank"
            href="https://wa.me/{{ getBranchWhatsapp() }}"
          >
            <i class="fa-brands fa-whatsapp" style="font-size: 23px"></i>
          </a>
          <a
            mat-fab
            [matTooltip]="'PROFILE_PAGE.TOOLTIP_MAP' | translate"
            color="accent"
            class="icon-sm-button"
            target="_blank"
            href="https://www.google.com/maps/search/?api=1&query={{
              promocion.branch.latitude
            }}%2C{{ promocion.branch.longitude }}"
          >
            <mat-icon svgIcon="room"></mat-icon>
          </a>
        </div>
        <button
          class="btn btn-primary my-2 divisa-col-12 divisa-col-md-6 mx-auto"
          (click)="reservar()"
        >
          {{ "HOME_BRANCHES.RESERVE_BUTTON" | translate }}
          <!--  <mat-icon iconPositionEnd svgIcon="payments"></mat-icon> -->
        </button>
      </div>
    </div>
  </div>
</div>
